var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgTickCircle(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-535-1178H905v4265H-535z"
  }), React.createElement("path", {
    d: "M-535-226H905v406H-535z"
  }), React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFA203"
  }), React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M16.76 7.025a.75.75 0 011.216.873l-.055.077-7.466 9.128a.75.75 0 01-1.04.117l-.07-.062-3.875-3.874a.75.75 0 01.99-1.123l.07.062 3.289 3.288 6.94-8.486z"
  })));
}

export default SvgTickCircle;